<panel width="450">
	<form>
		<h1>{{ 'company.accounting-plans.resume-and-delete-unissued-invoices-confirmation-header' | translate }}</h1>
		<section>
			<h3>{{ 'company.accounting-plans.resume-and-delete-unissued-invoices-confirmation-description' | translate }}</h3>
			<custom-select [label]="'company.accounting-plans.resume-and-delete-unissued-invoices-confirmation-select' | translate"
						   [placeholder]="'general.select' | translate"
						   [selectList]="deleteInvoicesSelect"
						   [(value)]="deleteInvoices"
						   [required]="true"></custom-select>
		</section>
		<section>
			<button ghost (click)="close()" [label]="'general.cancel' | translate"></button>
			<button confirm (click)="confirm()" [label]="'general.save' | translate"></button>
		</section>
	</form>
</panel>
